module.exports = __webpack_public_path__ + "static/media/alensa1.eb026e2d.jpg";